import React, { useCallback, useState } from 'react';
import swal from 'sweetalert';
import { Link } from 'react-router-dom';
import txtImage from '../../assets/images/json.png';
import Loader from '../../component/Loader/Loader';
import Breadcrumb from '../../component/Breadcrumb';
import {  Box, Grid, TextField, Typography } from '@mui/material';
import DropZoneComponent from '../../component/Dropzone';
import FormButtons from '../../component/FormSubmitCancelButtons';
import { uploadConfigFile } from '../../api/mappingApi';
// import { useOktaAuth } from '@okta/okta-react';
import { useMsal } from "@azure/msal-react";

const UploadConfigFile = () => {
  const { instance }  = useMsal();
  const accounts      = instance.getAllAccounts();
  //const {  authState } = useOktaAuth();
  const fileType = {
    'application/json':['.json']
  };
  const [projectName,setProjectName]  =  useState('');
  const [file,setFile]                =  useState([]);
  const [showLoader, setShowLoader]   =  useState(false);
  const handleDrop = useCallback((acceptedFile) => {
    if(acceptedFile.length < 1){
      swal({
        title: 'Error',
        text: 'Please upload vaild file with extension JSON.',
        icon: "error",
        dangerMode: true,
      });
      return;
    }
    //console.log('file type',acceptedFile[0]?.type)
    let fileUploadType = acceptedFile[0]?.type;
    let type = 'application/json';
    if(!fileUploadType.match(type)){
      swal({
        title: 'Error',
        text: 'Please upload valid file with extension json.',
        icon: "error",
        dangerMode: true,
      });
      return;
    }
    setFile(acceptedFile[0]);
  },[]);
    

  const submitFormFile = async () => {
    if(file.length === 0){
      swal({
        title: "Error",
        text: "No file uploaded.",
        icon: "error",
      })
      return;
    }
    if(projectName === ''){
      swal({title: "Error", text: "Project Name is required.",icon: "error"})
      return;
    }

    const formData = new FormData(); 
      formData.append('uploadedFile', file);
      formData.append('project_name', projectName);
      //formData.append('added_by', authState?.accessToken?.claims?.sub);
      // formData.append('added_by', accounts[0]?.username);
      formData.append('added_by', 'adminconfig@oncueplus.onmicrosoft.com');
      setShowLoader(true);
      await(uploadConfigFile(formData));
      setShowLoader(false);
      setFile([]);
      setProjectName('');
      swal({
        title: "Success",
        text: 'Config file data stored successfully.',
        icon: "success",
    })



    // const fileReader = new FileReader();
    // fileReader.readAsText(file, "UTF-8");
    // fileReader.onload = e => {
    //   const arrayData = JSON.parse(e.target.result);
    //   setShowLoader(true);
    //   setFileDataInStorage(arrayData);
    // };

    // const setFileDataInStorage = async(data) => {

    //   for(let key in data){
    //     if(key === 'Connections' || key === 'Parameters' || key === 'Events' || key === 'ECURequestPGN' || key === 'ECUReceiveMessages' || key === 'ECUConstantTxMessages' || key === 'HomePage' || key === 'ECUIDDefinitions' || key === 'ECUTransmitMessages' || key === 'Modbus'){
    //       let existingData = JSON.parse(localStorage.getItem(key));
    //       let mergedArrays;
    //       if(existingData != null && existingData.length > 0){
    //         if(key === 'Parameters'){
    //           mergedArrays   = existingData?.map((param)=> {
    //             const newObject  =  data[key]?.find(newParam => param.Addr === newParam.Addr); 
    //             return newObject ? {...param, ...newObject} : param;
    //           })
    //           data[key].forEach(newObj => {
    //             if(!existingData?.some(oldObj => oldObj.Addr === newObj.Addr)){
    //               mergedArrays.push(newObj);
    //             }
    //           });
    //         } else if(key === 'Events'){
    //           mergedArrays = existingData?.map((event)=> {
    //             const newObject  =  data[key]?.find(newEvent => event.EId === newEvent.EId); 
    //             return newObject ? {...event, ...newObject} : event;
    //           })
    //           data[key].forEach(newObj => {
    //             if(!existingData?.some(oldObj => oldObj.EId === newObj.EId)){
    //               mergedArrays.push(newObj);
    //             }
    //           });
    //         } else if(key === 'Connections'){
    //           mergedArrays = existingData?.map((conn)=> {
    //             const newObject  =  data[key]?.find(newConn => conn.LParam === newConn.LParam); 
    //             return newObject ? {...conn, ...newObject} : conn;
    //           })
    //           data[key].forEach(newObj => {
    //             if(!existingData?.some(oldObj => oldObj.LParam === newObj.LParam)){
    //               mergedArrays.push(newObj);
    //             }
    //           });
    //         } else if(key === 'Modbus'){
    //           mergedArrays = existingData?.map((modBus)=> {
    //             const newObject  =  data[key]?.find(newModBus => modBus.Addr === newModBus.Addr); 
    //             return newObject ? {...modBus, ...newObject} : modBus;
    //           })
    //           data[key].forEach(newObj => {
    //             if(!existingData?.some(oldObj => oldObj.Addr === newObj.Addr)){
    //               mergedArrays.push(newObj);
    //             }
    //           });
    //         } else {
    //           existingData.push(...data[key]);
    //           mergedArrays = existingData;
    //         }
    //       } else {
    //         mergedArrays = data[key];
    //       }
    //       localStorage.setItem(key,JSON.stringify(mergedArrays));
    //     }
    //   }
    //   const formData = new FormData(); 
    //   formData.append('uploadedFile', file);
    //   formData.append('project_name', projectName);
    //   formData.append('added_by', authState?.accessToken?.claims?.sub);
    //   const result = await(uploadConfigFile(formData));
    //   setShowLoader(false);
    //   setFile([]);
    //   setProjectName('');
    //   swal({
    //     title: "Success",
    //     text: 'Config file data stored successfully.',
    //     icon: "success",
    //   })
    // }
  };

  const emptyFileState = () => {
    setFile([]);
  };

  const changeHandler = (e) => {
    setProjectName(e.target.value);
  }

  return (
    <>
      {showLoader && 
        <Loader />
      }
      <Breadcrumb title="Add New Project">
        <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
          Dashboard
        </Typography>
        <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
          New Project
        </Typography>
      </Breadcrumb>
      <Box component="section">
        <Grid className="contentBox">
          <Grid container direction="row">
            <Grid item xs={12} sm={12} md={4}>
              <TextField
                fullWidth 
                margin='desnse'
                value={projectName}
                onChange={changeHandler}
                name="project_name"
                label="Project Name"
                error={projectName === ""}
                helperText={projectName === "" ? "Required Field!" : " "}
              />
            </Grid>
          </Grid>
          <h2>Upload Config File</h2>
          <DropZoneComponent onDrop={handleDrop} fileType={fileType} />
          {file != '' &&
            <h3>File - <img style={{width:'20px'}} alt="json" src={txtImage}  /> {file.name}</h3>
          }
          <FormButtons onSubmit={submitFormFile}  onCancel={emptyFileState} />
        </Grid>
      </Box>
    </>
  );
};

export default UploadConfigFile;
